





























import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore, Dialog,
} from '@kasasa/fbase-components/lib';
import {
  KNoticeContainer,
} from '@kasasa/fbase-components';
import { Cycle } from '@/api/cycles';
import { CycleTransactionCount } from '@/api/rewardsvalidation/';
import TransactionCountHistoryGraph from '@/components/rewardsvalidation/TransactionCountHistoryGraph.vue';

interface TabItem {
  count: CycleTransactionCount;
  friendlyName: string;
}

@Component({
  components: {
    TransactionCountHistoryGraph,
  },
})
export default class TransactionCountCard extends Vue {
  @Prop() transactionCounts!: CycleTransactionCount[];

  @Prop() cycles!: Cycle[];

  tabItems: TabItem[] = [];

  selectedTabItem: number = 0;

  readonly transactionTypeNameMap: Map<string, string> = new Map<string, string>([
    ['ACH_CREDIT', 'ACH Credit'],
    ['ACH_DEBIT', 'ACH Debit'],
    ['ATM_FEE_REFUND', 'ATM Fee Refund'],
    ['ATM_WITHDRAWAL', 'ATM Withdrawal'],
    ['BILL_PAY', 'Bill Pay'],
    ['COMBINED_ATM_FEE_REFUNDS', 'Combined ATM Fee Refunds'],
    ['CREDIT_CARD_PURCHASE', 'Credit Card Purchase'],
    ['CREDIT_CARD_RETURN', 'Credit Card Return'],
    ['FOREIGN_ATM_USAGE_FEE', 'Foreign ATM Usage Fee'],
    ['FOREIGN_ATM_USAGE_FEE_REFUND', 'Foreign ATM Usage Fee Refund'],
    ['POS', 'POS'],
    ['POS_PIN', 'POS-PIN'],
    ['POS_REFUND', 'POS Refund'],
    ['POS_SIGNATURE', 'POS-Signature'],
    ['REALTUNES', 'REALTunes'],
    ['TERMINAL_ATM_USAGE_FEE', 'Terminal ATM Usage Fee'],
    ['TUNES_APPLE', 'REALTunes Purchase - Apple'],
    ['TUNES_AMAZON', 'REALTunes Purchase - Amazon'],
    ['TUNES_GOOGLE', 'REALTunes Purchase - Google'],
    ['TOTAL_TRANSACTIONS', 'Total Transactions'],
  ]);

  mounted() {
    this.buildTabs();
  }

  @Watch('transactionCounts')
  buildTabs() {
    this.tabItems = [];
    this.transactionCounts.forEach((transactionCount: CycleTransactionCount) => {
      const friendlyName: string | null = this.getFriendlyTransactionType(transactionCount.transactionType);

      // Only show transaction types that are in the map.
      if (friendlyName) {
        this.tabItems.push({
          count: transactionCount,
          friendlyName,
        });
      }
    });

    this.tabItems = this.tabItems.sort((a: TabItem, b: TabItem): number => a.friendlyName.localeCompare(b.friendlyName));

    this.selectedTabItem = 0;
  }

  getFriendlyTransactionType(transactionType: string): string | null {
    return this.transactionTypeNameMap.has(transactionType) ? this.transactionTypeNameMap.get(transactionType) as string : null;
  }

  getCountChipColorClass = (item: CycleTransactionCount): string => {
    let className = 'countChip ';

    if (!item.yellowThresholdMinimum || !item.yellowThresholdMaximum || !item.greenThresholdMinimum || !item.greenThresholdMaximum) {
      className += 'greyChip';
    } else if (item.count < item.greenThresholdMinimum) {
      if (item.count < item.yellowThresholdMinimum) {
        className += 'redChip';
      } else {
        className += 'yellowChip';
      }
    } else if (item.count > item.greenThresholdMaximum) {
      if (item.count > item.yellowThresholdMaximum) {
        className += 'redChip';
      } else {
        className += 'yellowChip';
      }
    } else {
      className += 'greenChip';
    }


    return className;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
